import Cookies from 'js-cookie';
import { getDomain } from './browser';

const TOKEN_KEY = 'client_cabinet_token';
const REFRESH_TOKEN_KEY = 'client_cabinet_refresh_token';
const AUTHENTICATED_KEY = 'isAuthenticated';
const DOMAIN = process.env.STAGE === 'dev'
  ? null
  : `${process.env.COOKIE_DOMAIN}${getDomain()[0]}`;

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

export function getToken() {
  const token = Cookies.get(TOKEN_KEY);
  return token || sessionStorage.getItem(TOKEN_KEY);
}

export function getParsedToken() {
  const token = getToken();
  if (!token) {
    return null;
  }
  return parseJwt(token);
}

export function setToken(token, remember = true) {
  if (remember) {
    Cookies.set(TOKEN_KEY, token, { expires: remember ? 30 : 0, domain: DOMAIN });
  } else {
    sessionStorage.setItem(TOKEN_KEY, token);
  }
}

export function setRefreshToken(token) {
  Cookies.set(REFRESH_TOKEN_KEY, token, { expires: 30, domain: DOMAIN });
}

export function getRefreshToken() {
  return Cookies.get(REFRESH_TOKEN_KEY);
}

export function setAuthenticatedCookies(flag) {
  if (flag) {
    Cookies.set(AUTHENTICATED_KEY, true);
  }
  Cookies.remove(AUTHENTICATED_KEY, { path: '', domain: DOMAIN });
}

export function destroy() {
  setAuthenticatedCookies(false);
  Cookies.remove(TOKEN_KEY, { path: '', domain: DOMAIN });
  Cookies.remove(REFRESH_TOKEN_KEY, { path: '', domain: DOMAIN });
  sessionStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated() {
  return !!getToken();
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/auth.js